module.exports = __webpack_public_path__ + "img/WP2023-see-you-1200-1200.53ae6be2.png";